"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.map.js");
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _usePrefixCls = require("../_utils/hooks/usePrefixCls");
var _Button = _interopRequireDefault(require("./Button"));
var _excluded = ["className", "style", "buttons"],
  _excluded2 = ["text"];
var Group = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var className = props.className,
    style = props.style,
    buttons = props.buttons,
    rest = (0, _objectWithoutProperties2.default)(props, _excluded);
  var prefixCls = (0, _usePrefixCls.usePrefixCls)('btn__group');
  var classes = (0, _classnames.default)(prefixCls, className);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes
  }, buttons && buttons.map(function (btn, index) {
    if (btn.render) {
      return /*#__PURE__*/_react.default.createElement("span", {
        className: "".concat(prefixCls, "-item"),
        key: index
      }, btn.render);
    }
    var text = btn.text,
      rest = (0, _objectWithoutProperties2.default)(btn, _excluded2);
    return /*#__PURE__*/_react.default.createElement(_Button.default, (0, _extends2.default)({}, rest, {
      key: index
    }), text);
  }));
});
Group.displayName = 'Group';
var _default = exports.default = Group;